export default __webpack_public_path__ + "static/media/clock.f976bc10.svg";